// extracted by mini-css-extract-plugin
export default {"div":"LayerTitle_div__u2FA-","label":"LayerTitle_label__Y9oZ-","icon":"LayerTitle_icon__tlUT3"};